import React, { Component } from "react";
import {
  View,
  Image,
  TouchableOpacity,
  FlatList,
  ScrollView,
} from "react-native";
import { icons } from "../theme/icons";
import { appStyles, componentStyles } from "../theme/styles";
import TextView from "../components/TextView";
import { serviceRequest, addtoCartRequest } from "../utils/api";
import LinearGradient from "react-native-linear-gradient";
import {
  blueLightColor,
  blueDarkColor,
  greenLightColor,
  greenDarkColor,
} from "../theme/colors";
import { persianNumber } from "../utils/utils";
import ServiceInfoItem from "../components/ServiceInfoItem";
import Waiting from "../components/Waiting";
import { wp } from "../utils/responsive";

export default class ServiceInfoListScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      selectedCount: 0,
    };
  }

  _keyExtractor = (item, index) => index.toString();

  renderRow({ item, index }) {
    return (
      <ServiceInfoItem
        data={item}
        navigation={this.props.navigation}
        onPress={() => {
          this.setState({
            waiting: true,
          });
          addtoCartRequest(item.id, (isConnect, response) => {
            if (isConnect && response.isSuccess) {
              this.getData();
            } else {
              this.setState({
                waiting: false,
              });
            }
          });
        }}
      />
    );
  }

  render() {
    return (
      <View style={appStyles.flex1}>
        <ScrollView>
          <View style={appStyles.toolbarWraper}>
            <Image
              source={icons["ad"]}
              style={[appStyles.toolbarIcon, { tintColor: "#31BFCF" }]}
            />
            <TextView style={appStyles.toolbarTitle}>
              {this.props.route.params.title}
            </TextView>
            <TouchableOpacity
              onPress={() => {
                this.props.navigation.goBack();
              }}
            >
              <Image source={icons["back"]} style={appStyles.backIcon} />
            </TouchableOpacity>
          </View>
          <View style={{ flex: 1, marginBottom: 110}}>
            <FlatList
              data={this.state.data}
              numColumns={3}
              style={{ backgroundColor: "white" }}
              renderItem={this.renderRow.bind(this)}
              keyExtractor={this._keyExtractor}
            />
          </View>
        </ScrollView>
        <View
          style={[
            appStyles.bottomView,
            appStyles.center,
            appStyles.shadow,
            {
              minHeight: 100,
              backgroundColor: "white",
              marginTop: 5,
            },
          ]}
        >
          <TouchableOpacity
            activeOpacity={0.5}
            onPress={() => {
              if (this.state.selectedCount > 0) {
                this.props.navigation.navigate("viewCart");
              }
            }}
          >
            <LinearGradient
              start={{ x: 0, y: 0 }}
              end={{ x: 1, y: 0 }}
              colors={
                this.state.selectedCount > 0
                  ? [greenLightColor, greenDarkColor]
                  : [blueLightColor, blueDarkColor]
              }
              style={[
                componentStyles.gradinatButton,
                {
                  width: wp(90),
                  borderRadius: 25,
                  height: 50,
                },
              ]}
            >
              <View style={componentStyles.countWraper}>
                <TextView
                  isbold={true}
                  style={{ color: greenDarkColor, fontSize: 18 }}
                >
                  {persianNumber(this.state.selectedCount)}
                </TextView>
              </View>
              <TextView isbold={true} style={componentStyles.requestText}>
                درخواست خدمات
              </TextView>
            </LinearGradient>
          </TouchableOpacity>
        </View>
        <Waiting waiting={this.state.waiting} />
      </View>
    );
  }

  componentWillMount() {
    this.getData();
    this.props.navigation.addListener("didFocus", (payload) => {
      this.getData();
    });
  }

  getData() {
    this.setState({
      waiting: true,
    });
    serviceRequest(this.props.route.params.id, (isConnect, response) => {
      this.setState({
        waiting: false,
      });
      if (isConnect && response.isSuccess) {
        var data = response.data.servicedetails;
        data.sort((a, b) => {
          if (a.priority < b.priority) {
            return -1;
          }
          if (b.priority > a.priority) {
            return 1;
          }
          return 0;
        });
        this.setState({
          data: data,
          selectedCount: response.data.all_service_selected,
        });
      }
    });
  }
}
